__turbopack_context__.v({
  "container": "issueTile-module-scss-module__gK-KUq__container",
  "dealListPanelGroupItem": "issueTile-module-scss-module__gK-KUq__dealListPanelGroupItem",
  "mobileTabSelect": "issueTile-module-scss-module__gK-KUq__mobileTabSelect",
});
